var map = {
	"./1 Pair.mp3": 739,
	"./2 Pairs.mp3": 740,
	"./3 of a Kind.mp3": 741,
	"./4 of a Kind.mp3": 742,
	"./5 of a Kind.mp3": 743,
	"./Flush.mp3": 744,
	"./Full House.mp3": 745,
	"./INC Straight Flush.mp3": 746,
	"./INC Straight.mp3": 747,
	"./Straight Flush.mp3": 748,
	"./Straight.mp3": 749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 738;